import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { updateElements } from '../api'
import { contentKeys } from '../queryKeys'

const useUpdateContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(updateElements, {
    onError: () => {
      errorToast('Something went wrong. Please try again.')
    },
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
    },
  })
}

export default useUpdateContentMutation
